module.exports = __webpack_public_path__ + "static/media/MikeP.4e82fea8.png";